// src/i18n/en/operacion.ts
// «Operación» (w7.u2) — route /operacion, Dirección. Metric names are
// translated by id in `insightV2.metrics`.
export const operacion = {
  name: 'Operation |||| Operation',
  subtitle: "The GM's figures, with what's failing underneath",

  noChanges: 'No figure changed enough against the previous period.',

  // «Three things that changed»: one sentence per change the API states.
  changes: {
    periodDay: '%{day}',
    periodRange: '%{from} to %{to}',
    ops_arrivals: {
      up: 'Arrivals went up from %{previous} to %{current} (%{change}) against the previous period (%{period}).',
      down: 'Arrivals went down from %{previous} to %{current} (%{change}) against the previous period (%{period}).',
    },
    ops_self_service_completed: {
      up: 'Self-service completed went up from %{previous} to %{current} (%{change}) against the previous period (%{period}).',
      down: 'Self-service completed went down from %{previous} to %{current} (%{change}) against the previous period (%{period}).',
    },
    ops_containment: {
      up: 'Arrivals resolved without reception went up from %{previous} to %{current} (%{change}) against the previous period (%{period}).',
      down: 'Arrivals resolved without reception went down from %{previous} to %{current} (%{change}) against the previous period (%{period}).',
    },
    ops_pre_checkin_share: {
      up: 'Arrivals with pre-check-in went up from %{previous} to %{current} (%{change}) against the previous period (%{period}).',
      down: 'Arrivals with pre-check-in went down from %{previous} to %{current} (%{change}) against the previous period (%{period}).',
    },
    ops_time_to_key_median: {
      up: 'Time to key went up from %{previous} to %{current} (%{change}) against the previous period (%{period}).',
      down: 'Time to key went down from %{previous} to %{current} (%{change}) against the previous period (%{period}).',
    },
    ops_incidents: {
      up: 'Incidents went up from %{previous} to %{current} (%{change}) against the previous period (%{period}).',
      down: 'Incidents went down from %{previous} to %{current} (%{change}) against the previous period (%{period}).',
    },
  },

  sections: {
    stepFunnel: 'Kiosk journeys',
    times: 'Times',
    errorsAbandon: 'Errors and abandonment',
    preCheckin: 'Pre-check-in',
    identification: 'Identification',
    other: 'Other indicators',
  },

  export: {
    metric: 'Metric',
    value: 'Value',
  },

  help: {
    title: 'Operation',
    description:
      "The GM's weekly page: six figures (arrivals, self-service completed, resolved without reception, time to key, arrivals with pre-check-in and incidents) with their change against the previous period of the same length, the three figures that changed most and, below them, what's failing — kiosk journeys, times, errors and abandon reasons, pre-check-in and identification.",
    features: {
      cards: 'Every figure carries its change against the previous period (in points for percentages, in time for the time to key), green when it improves and red when it worsens, and a grey stamp with the data\'s freshness or, when absent, the exact remedy — never "estimated" or "unknown".',
      panels: 'The supporting panels group the rest of the Operación indicators by topic.',
    },
    tips: {
      property: 'Switch property at the top left; the default period is the last 30 days.',
    },
  },
};

export default operacion;
